module.exports = __webpack_public_path__ + "static/media/HCMM265.184a7376.jpg";